import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { InteractiveMapLocation } from "@redotech/redo-common-model-location-common/interactive-map-location";
import { useTranslation } from "@redotech/redo-i18n";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import type { ReturnDropoff } from "@redotech/redo-return-core-common/return";
import { memo } from "react";
import {
  DropoffLocationsButton,
  DropoffLocationsSearchParams,
} from "./dropoff-locations-button";

export const DropoffLabelButtons = memo(function DropoffLabelButtons({
  dropoffs,
  returnId,
  customerCountry,
  autoOpen = false,
  modalTitle,
  modalSubtitle,
  searchDropoffLocations,
  onOpenUrl,
}: {
  dropoffs: ReturnDropoff;
  returnId: string;
  customerCountry?: string;
  autoOpen?: boolean;
  modalTitle?: string;
  modalSubtitle?: string;
  searchDropoffLocations: (
    params: DropoffLocationsSearchParams,
  ) => Promise<InteractiveMapLocation[]>;
  onOpenUrl: (url: string) => void;
}) {
  const { t } = useTranslation();
  const firstQrCodeUrl = dropoffs.qrCodes[0]?.qrCodeUrl;

  return (
    <Flex flexDirection="row" gap="sm">
      {!!firstQrCodeUrl && (
        <RedoButton
          hierarchy="secondary"
          IconLeading={QrCode}
          onClick={() => onOpenUrl(firstQrCodeUrl)}
          text={t("QR code")}
        />
      )}
      <DropoffLocationsButton
        autoOpen={autoOpen}
        customerCountry={customerCountry}
        modalSubtitle={modalSubtitle}
        modalTitle={modalTitle}
        returnId={returnId}
        searchDropoffLocations={searchDropoffLocations}
      />
    </Flex>
  );
});
